import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["data"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery } from '@apollo/client';
import dayjs from 'dayjs';
import gql from 'graphql-tag';
import * as R from 'ramda';
import { useMemo } from 'react';
export var GuidesAPIGQL = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query Guides($soap_id: bigint) {\n    guides(where: { clinic_soap_id: { _eq: $soap_id } }) {\n      data\n      id\n      updated_at\n      created_at\n      clinic_soap_id\n    }\n  }\n"])));
export var SoapBySoapIDGQL = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query SoapBySoapID($soap_id: Int) {\n    clinic_soaps(where: { id: { _eq: $soap_id } }, order_by: { created_at: desc }) {\n      id\n      client_id\n    }\n  }\n"])));
export var useGetGuideBySoap = function useGetGuideBySoap(soap_id) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _useQuery = useQuery(GuidesAPIGQL, {
    variables: {
      soap_id: soap_id,
      skip: !soap_id || !enabled
    }
  }),
      data = _useQuery.data,
      rest = _objectWithoutProperties(_useQuery, _excluded);

  var _useMemo = useMemo(function () {
    var guide = R.pathOr(null, ['guides', 0, 'data'], data);
    var date = dayjs(R.pathOr(null, ['guides', 0, 'updated_at'], data)).format('YYYY-MM-DD');
    var client_id = R.pathOr(null, ['clinic_soaps', 0, 'client_id'], data);
    return {
      guide: guide,
      date: date,
      client_id: client_id
    };
  }, [data]),
      guide = _useMemo.guide,
      date = _useMemo.date,
      client_id = _useMemo.client_id;

  return _objectSpread({
    guide: guide,
    date: date,
    client_id: client_id
  }, rest);
};
export var useCheckAnalysisGuideMisMatch = function useCheckAnalysisGuideMisMatch(soap_id, clientID) {
  var _useQuery2 = useQuery(SoapBySoapIDGQL, {
    variables: {
      soap_id: soap_id,
      skip: !soap_id
    }
  }),
      data = _useQuery2.data,
      loading = _useQuery2.loading;

  var isMisMatch = useMemo(function () {
    if (loading || !soap_id) {
      return true;
    }

    var client_id = R.pathOr(null, ['clinic_soaps', 0, 'client_id'], data);
    return Boolean(clientID) && clientID != client_id;
  }, [data, clientID, soap_id, loading]);
  return {
    isMisMatch: isMisMatch,
    loading: loading
  };
};